const instrumentList = require('../../Material.json')

//器具数据
const instrumentAll = instrumentList as any;
//等级分组
const groupInstrumentByLevel = {} as any;
let groupInstrumentCountByLevel = {} as any;

//年份分组
const groupInstrumentByYear = {} as any;
let groupInstrumentCountByYear = {} as any;

//形态分组
const groupInstrumentByShape = {} as any;
let groupInstrumentCountByShape = {} as any;


instrumentAll.forEach((instrument: any) => {
    //1.按照"级别"进行分组
    {
        if(groupInstrumentByLevel[instrument['等级']] == undefined){
            groupInstrumentByLevel[instrument['等级']] = [];
            groupInstrumentCountByLevel[instrument['等级']] = {name: instrument['等级'], value: 0};
        }
        groupInstrumentCountByLevel[instrument['等级']].value += 1;
        groupInstrumentByLevel[instrument['等级']].push(instrument);
    }
    //2.按照"年"
    {
        if(groupInstrumentByYear[instrument['年份']] == undefined){
            groupInstrumentByYear[instrument['年份']] = [];
            groupInstrumentCountByYear[instrument['年份']] = {name: instrument['年份'], value: 0};
        }
        groupInstrumentCountByYear[instrument['年份']].value += 1;
        groupInstrumentByYear[instrument['年份']].push(instrument);
    }
    //3.按照"形态"
    {
        if(groupInstrumentByShape[instrument['特征形态']] == undefined){
            groupInstrumentByShape[instrument['特征形态']] = [];
            groupInstrumentCountByShape[instrument['特征形态']] = {name: instrument['特征形态'], value: 0};
        }
        groupInstrumentCountByShape[instrument['特征形态']].value += 1;
        groupInstrumentByShape[instrument['特征形态']].push(instrument);
    }
});
groupInstrumentCountByLevel = Object.values(groupInstrumentCountByLevel);
groupInstrumentCountByYear = Object.values(groupInstrumentCountByYear);
groupInstrumentCountByShape = Object.values(groupInstrumentCountByShape);
export { instrumentAll, groupInstrumentByLevel, groupInstrumentByYear,groupInstrumentByShape, groupInstrumentCountByYear, groupInstrumentCountByLevel, groupInstrumentCountByShape}
